import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import UserPanel from './UserPanel';
import { useAuth } from '../contexts/AuthContext';

const Header = ({ onOpenChangeLogs, onOpenUserManagement, onResetPassword, onToggleMobileSidebar }) => {
  const { user, logout } = useAuth();
  const [userPanelOpen, setUserPanelOpen] = useState(false);

  return (
    <>
      <header className="h-16 lg:h-24 flex-shrink-0 flex items-center px-4 lg:px-6" style={{ backgroundColor: '#86bb46' }}>
        {/* Hamburger for mobile */}
        <button
          type="button"
          onClick={onToggleMobileSidebar}
          className="lg:hidden p-2 rounded-lg text-white/80 hover:text-white hover:bg-white/20 mr-2"
          aria-label="Toggle menu"
        >
          <Menu size={22} />
        </button>

        <div className="hidden lg:block w-48 flex-shrink-0" />

        <div className="flex-1 flex justify-center">
          <div className="text-center">
            <h1 className="text-xl lg:text-3xl font-bold text-white tracking-wide">
              AGS Sales Hub
            </h1>
            <p className="text-xs lg:text-sm text-white/90 mt-0.5 hidden sm:block">
              Smarter sales analytics
            </p>
          </div>
        </div>

        <div className="w-auto lg:w-48 flex items-center justify-end flex-shrink-0">
          <button
            type="button"
            onClick={() => setUserPanelOpen(true)}
            className="p-0 border-0 bg-transparent cursor-pointer hover:opacity-90 transition-opacity"
            title="Account"
            aria-label="Open account panel"
          >
            <img
              src="/ags-log-nob.png"
              alt="American Green Solutions"
              className="h-11 lg:h-16 w-auto max-h-11 lg:max-h-16 object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '/logo.jpg';
              }}
            />
          </button>
        </div>
      </header>

      <UserPanel
        isOpen={userPanelOpen}
        onClose={() => setUserPanelOpen(false)}
        user={user}
        onLogout={() => { logout(); setUserPanelOpen(false); }}
        onOpenChangeLogs={onOpenChangeLogs}
        onOpenUserManagement={onOpenUserManagement}
        onResetPassword={onResetPassword}
      />
    </>
  );
};

export default Header;
